import { render } from "./NewSupplier.vue?vue&type=template&id=60a7ef16&scoped=true"
import script from "./NewSupplier.vue?vue&type=script&lang=js"
export * from "./NewSupplier.vue?vue&type=script&lang=js"

import "./NewSupplier.vue?vue&type=style&index=0&id=60a7ef16&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60a7ef16"]])

export default __exports__